// src/pages/Settings/components/SettingsTabs.jsx
import { NavLink } from 'react-router-dom';

interface SettingsTab {
  to: string;
  label: string;
}

export default function SettingsTabs({ items }: { items: SettingsTab[] }) {
  return (
    <nav className="settings-tabs" role="tablist" aria-label="Settings Tabs">
      {items.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          role="tab"
          className={({ isActive }) => `settings-tabs__item ${isActive ? 'is-active' : ''}`}
        >
          {it.label}
        </NavLink>
      ))}
    </nav>
  );
}
